import { Icon, NavBar, SearchBar, Toast, WhiteSpace } from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { PhoneFill } from "antd-mobile-icons";
import instance from "../../../util/axios";
const MailListFrom = styled.div`
  .body {
    // width:100%;
    // padding:10px;
  }
  .title {
    position: fixed;
    height: 100px;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    width: 100%;
    background-color: #ffffff;
  }
  .ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .li {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #797979;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // border-radius: 5px;
    margin-bottom: 10px;
  }
  .pdd {
    padding: 0 10px 0 10px;
    margin-top: 5.2rem;
  }
  .size {
    font-size: 22px;
  }
  .margin {
    position: fixed;
    height: 3rem;
    margin-top: 3rem;
    width: 100%;
    padding: 0px;
  }
  .left {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
  }
  .right {
    margin-right: 10px;
  }
  .s1 {
    font-size: 20px;
    font-weight: 550;
    color: #797979;
  }
  .s2 {
    margin-top: 12px;
    color: gray;
  }
  .am-navbar {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: 3rem;
    background-color: #ffffff;
    position: fixed;
    z-index: 9999;
    top: 0;
    width: 100%;
    color: #000000;
  }
  .titleName {
    width: 100%;
    background-color: #ffffff;
    height: 5rem;
    position: fixed;
  }
`;
interface Array1 {
  uuid: string;
  serialNumber: string;
  submitTime: string;
  workflowId: string;
  tableName: string;
}
export default function DrawingList() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [keyword, setKeyword] = useState<string>();
  const [drawList, setdrawList] = useState<Array1[]>([]);
  const history = useHistory();
  useEffect(() => {
    instance.get(`/erp/radOrder/mobile/getProduceOrderList`).then((resp) => {
      console.log(resp);
      // console.log(resp.data.Data.data)
      if (resp.data.Status === "1") {
        setdrawList(resp.data.Data.data);
        // console.log(staffList)
      }
    });
  }, []);
  const searchBarChange = useCallback((keyword) => {
    instance
      .get(`/erp/radOrder/mobile/getProduceOrderList?serialNumber=` + keyword)
      .then((resp) => {
        console.log(resp);
        if (resp.data.Status === "1") {
          setdrawList(resp.data.Data.data);
        }
      });
  }, []);
  const noSearch = useCallback(() => {
    instance.get(`/erp/radOrder/mobile/getProduceOrderList`).then((resp) => {
      console.log(resp);
      if (resp.data.Status === "1") {
        setdrawList(resp.data.Data.data);
      }
    });
  }, []);

  return (
    <>
      <MailListFrom>
        <div className="body">
          <div className="titleName">
            <NavBar
              className="orderNavBar"
              leftContent="返回"
              icon={
                <Icon
                  type="left"
                  onClick={() => {
                    window.location.href = "/colseWebView";
                  }}
                />
              }
            >
              查看图纸
            </NavBar>
            <SearchBar
              value={keyword}
              onChange={(value) => setKeyword(value)}
              placeholder="请输入单号"
              className="margin"
              onSubmit={() => {
                searchBarChange(keyword);
              }}
              onCancel={() => {
                setKeyword("");
                noSearch();
              }}
              // onChange={searchBarChange}
            />
          </div>

          <WhiteSpace />
          <div className="pdd">
            <ul className="ul">
              {drawList.map((item) => (
                <li
                  className="li"
                  onClick={() => {
                    window.location.href =
                      "/erp/drawinglist/querylist?" +
                      item.uuid +
                      "&" +
                      item.tableName;
                  }}
                >
                  <div className="left">
                    <span className="s1">{item.serialNumber}</span>
                    <span className="s2">
                      {item.submitTime.substring(0, 10)}
                    </span>
                  </div>
                  {/* <div className="right">客服名称</div> */}
                </li>
              ))}
            </ul>
          </div>
          {drawList.length === 0 && (
            <div style={{ textAlign: "center", marginTop: "8rem" }}>
              <span>暂无更多数据</span>
            </div>
          )}
        </div>
      </MailListFrom>
    </>
  );
}
